import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FileText } from "lucide-react";
import { api } from "../lib/api";
import { isPreview } from "../context/SiteContext";
import { Empty, PageTitle, Spinner } from "../components/ui";

export function RichText({ text }) {
  const blocks = [];
  (text || "").split("\n").forEach((raw) => {
    const l = raw.trim();
    const last = blocks[blocks.length - 1];
    if (!l) blocks.push({ t: "gap" });
    else if (l.startsWith("## ")) blocks.push({ t: "h", v: l.slice(3) });
    else if (l.startsWith("- ")) { if (last?.t === "ul") last.v.push(l.slice(2)); else blocks.push({ t: "ul", v: [l.slice(2)] }); }
    else if (last?.t === "p") last.v += `\n${l}`;
    else blocks.push({ t: "p", v: l });
  });
  return (
    <div className="flex flex-col gap-3 text-sm leading-relaxed text-gray-700">
      {blocks.map((b, i) => (b.t === "h" ? <h2 key={i} className="mt-2 text-lg font-bold text-bo-ink">{b.v}</h2>
        : b.t === "ul" ? <ul key={i} className="list-disc pl-5">{b.v.map((x, j) => <li key={j}>{x}</li>)}</ul>
          : b.t === "p" ? <p key={i} className="whitespace-pre-line">{b.v}</p> : null))}
    </div>
  );
}

export default function CmsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  useEffect(() => {
    setPage(null);
    api.get(`/pages/${slug}`, { params: isPreview() ? { preview: true } : {} }).then(({ data }) => setPage(data)).catch(() => setPage(false));
  }, [slug]);
  if (page === null) return <Spinner />;
  if (!page) return <Empty icon={FileText} title="Página não encontrada" />;
  return (
    <div className="bo-card p-6 sm:p-8" data-testid="cms-page">
      <PageTitle title={page.title} sub={page.preview ? "Pré-visualização do rascunho" : undefined} />
      <RichText text={page.body} />
    </div>
  );
}
